import { toast } from 'sonner';

import { EDIT_CONFLICT_TEXT, GONE_TEXT } from './edit-conflict-text';

const HANDLED = new Set<unknown>([EDIT_CONFLICT_TEXT, ...Object.values(GONE_TEXT)]);

let installed = false;

/**
 * An edit conflict (or a deletion by someone else) already has its own toast. Every caller
 * also reports its failed save with `toast.error(translateError(err))`, which
 * for a conflict is the very same sentence: drop those, centrally, instead of
 * editing each call site. The rich toast uses `toast.warning`, so it is unaffected.
 */
export function installConflictToastGuard(): void {
  if (installed) return;
  installed = true;
  const original = toast.error.bind(toast);
  toast.error = ((message: unknown, ...rest: unknown[]) => {
    if (HANDLED.has(message)) return undefined;
    return (original as (...a: unknown[]) => unknown)(message, ...rest);
  }) as typeof toast.error;
}
